<template>
	<b-form @submit.stop.prevent="save()">
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<div v-else-if="replacements.length > 0">
			<table class="table table-sm table-striped">
				<thead>
					<tr>
						<th></th>
						<th>Enable</th>
						<th>Expression</th>
						<th class="text-center">RegExp <a target="_blank" href="https://en.wikipedia.org/wiki/Regular_expression"><b-icon icon="box-arrow-up-right"/></a></th>
						<th class="text-center">Mid-word</th>
						<th class="text-center">Case<br />sensitive</th>
						<th>Replacement</th>
						<th class="text-right"><b-button @click="addReplacement()" variant="success" size="sm" v-b-tooltip.hover.left.v-success title="Add a replacement"><b-icon icon="plus"></b-icon></b-button></th>
					</tr>
				</thead>
				<draggable v-model="replacements" tag="tbody" handle=".handle">
					<tr v-for="(item, idx) in replacements" :key="idx">
						<td class="handle" style="vertical-align: middle"><b-icon icon="justify" font-scale="2"></b-icon></td>
						<td style="vertical-align: middle" class="text-center"><b-form-checkbox switch v-model="item.status" value="enabled" unchecked-value="disabled"/></td>
						<td>
							<b-form-input v-model="item.replace" :state="!item.error" @input="checkSyntax(item)" required/>
							<div class="text-danger text-center" v-if="item.error"><small>{{item.error.message}}</small></div>
						</td>
						<td class="text-center" style="vertical-align: middle"><b-form-checkbox v-model="item.regexp" @input="checkSyntax(item)"/></td>
						<td class="text-center" style="vertical-align: middle"><b-form-checkbox v-model="item.unbounded" :disabled="item.regexp"/></td>
						<td class="text-center" style="vertical-align: middle"><b-form-checkbox v-model="item['case-sensitive']"/></td>
						<td><b-form-input v-model="item.with" /></td>
						<td class="text-right">
							<b-button-group size="sm">
								<b-button
									@click="removeReplacement(idx)"
									size="sm"
									variant="danger"
									v-b-tooltip.hover.right.v-danger
									title="Delete replacement"
								><b-icon icon="trash"></b-icon></b-button>
							</b-button-group>
						</td>
					</tr>
				</draggable>
			</table>
			<b-form-row>
				<b-col>
					<b-form-group label="Try it out"><b-form-input v-model="testInput"></b-form-input></b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Result"><b-form-input readonly v-model="testOutput"></b-form-input></b-form-group>
				</b-col>
			</b-form-row>
		</div>
		<b-card v-else class="text-center text-muted p-5">No word replacements.<br />Word replacements allow you to replace words in chat with other words, when they show up in the chat widget or the alert widget.<br /><br /><br /><b-button @click="addReplacement()" variant="success"><b-icon icon="plus"></b-icon> Add a replacement</b-button><br /></b-card>
		<b-card class="text-center mb-3 mt-3" v-if="loading <= 0">
			<b-alert variant="danger" :show="!!saveError">{{saveError}}</b-alert>
			<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
				<b-button variant="primary" type="submit">Save settings</b-button>
			</b-overlay>
		</b-card>
	</b-form>
</template>

<script>
import draggable from "vuedraggable";
import debounce from 'debounce';

export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		replacements: [],
		testInput: '',
		testOutput: '',
	}},
	components: {
		draggable,
	},
	watch: {
		testInput: 'updateTestOutput',
		replacements: {
			handler: 'updateTestOutput',
			deep: true,
		},
	},
	mounted() {
		this.loading++;
		this.error = null;
		this.replacements = [];
		this.$api.get('textReplacements').then(replacements => {
			this.replacements = replacements;
		}, err => this.error = err).finally(() => {
			this.loading--;
		});
	},
	methods: {
		addReplacement() {
			this.replacements.push({ replace: '', with: '', status: 'enabled', regexp: false, unbounded: false, 'case-sensitive': false });
		},

		removeReplacement(idx) {
			this.replacements.splice(idx, 1);
		},

		checkSyntax(item) {
			item.error = null;
			if(!item.regexp) return;
			try {
				new RegExp(item.replace, 'g');
			} catch(err) {
				item.error = err;
			}
		},

		updateTestOutput: debounce(function() {
			this.testOutput = (this.replacements||[]).reduce((val, r) => {
				if(r.status != 'enabled') return val;
				try {
					return val.replace(new RegExp(r.regexp ? r.replace : `${r.unbounded?'':'\\b'}${r.replace.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')}${r.unbounded?'':'\\b'}`, `g${r['case-sensitive']?'':'i'}`), r.with);
				} catch(e) {
					return val;
				}
			}, this.testInput);
		}, 100),

		async save() {
			try {
				this.saving++;
				this.saveError = null;
				await this.$api.post('textReplacements', this.replacements);
				this.$bvToast.toast('Successfully saved', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
			} catch(e) {
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	}
};
</script>

<style>
th.rotate {
  /* Something you can count on */
  height: 90px;
  white-space: nowrap;
}

th.rotate > div {
  transform:
  translate(-7px, 2px)
  rotate(-60deg);
  width: 30px;
}
th.rotate > div > span {
  padding: 5px 10px;
}

.handle {
	cursor: move;
}
</style>
